module.exports = __webpack_public_path__ + "img/PIE_CHART.e41de080.svg";